export default __webpack_public_path__ + "media/images/child_seat_icon-632073f6c304b63fedc060a4f78f1e09.png";